const loadImage = (url, loadCallback) =>
  new Promise((resolve, reject) => {
    let image = new Image();
    image.onload = () => {
      if (loadCallback) {
        loadCallback();
      }
      resolve(image);
    };
    image.onerror = () => {
      let message = 'Could not load image at ' + url;
      reject(url);
    };
    image.src = url;
  });

export default loadImage;



// WEBPACK FOOTER //
// ./src/utils/loadImage.js